import * as React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";

import { CONTACT_LINK_BATSOFT } from "@config/links";

import { Container } from "@ui/Atoms/Grid";
import { Heading, OptionPanel, Paragraph, Row, Column } from "@ui/Atoms";
import { InfoMessage } from "@ui/Molecules";
import theme from "@ui/themes/default";
import { Alert } from "@ui/Assets/Symbolicons/Alert";

import { Markdown } from "@containers/Markdown";
import { ScrollToTop } from "@containers/ScrollToTop";

import { useTranslate } from "@hooks/useTranslate";

import { getLanguage } from "@soft/redux/localisation/localisation.selectors";

const ValidateContractInvalidLink = () => {
  const translate = useTranslate("batsoft_pwa_bookings_to_validate");
  const lang = useSelector(getLanguage);

  return (
    <StyledContainer>
      <OptionPanel>
        <ScrollToTop />
        <Row>
          <Column pushXs={1} xs={10} pushLg={2} lg={8}>
            <OptionPanelContentWrapper>
              <Alert variant="line" size={64} color={theme.colors.red700} />
              <HeadingStyled type="h6">
                {translate("invalid_link_header")}
              </HeadingStyled>
              <Paragraphs>
                <Paragraph type="body">
                  {translate("invalid_link_description")}
                </Paragraph>
              </Paragraphs>
              <InfoMessageWrapper>
                <InfoMessage
                  message={
                    <span>
                      <Markdown>
                        {translate("invalid_link_contact_us", {
                          link: `/${lang}${CONTACT_LINK_BATSOFT}`,
                        })}
                      </Markdown>
                    </span>
                  }
                />
              </InfoMessageWrapper>
            </OptionPanelContentWrapper>
          </Column>
        </Row>
      </OptionPanel>
    </StyledContainer>
  );
};

export { ValidateContractInvalidLink };

const InfoMessageWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${props => props.theme.margins.base_x8};
`;

const HeadingStyled = styled(Heading)`
  margin: ${props => props.theme.margins.base} 0
    ${props => props.theme.margins.base_x4};
`;

const OptionPanelContentWrapper = styled.div`
  text-align: center;
  margin: 0 auto;
`;

const Paragraphs = styled.div`
  text-align: left;
`;

const StyledContainer = styled(Container)`
  ${props => props.theme.breakpoints.desktop} {
    padding-top: ${props => props.theme.margins.base_x4};
    padding-bottom: ${props => props.theme.margins.base_x4};
  }
`;
